export default "__VITE_ASSET__qyfcaPfe__"